import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'charla-html-modal',
  templateUrl: './html-modal.component.html'
})
export class HtmlModalComponent {
  @Input() html = '';

  constructor(public activeModal: NgbActiveModal) {}


}